import { Component } from '@angular/core';
import { AddCategoryForm } from '../../../../components/admin-dashboard-component/categories/add-category-form/add-category-form';

@Component({
  selector: 'app-add-category',
  imports: [AddCategoryForm],
  templateUrl: './add-category.html',
  styleUrl: './add-category.scss',
})
export class AddCategory {}
